/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../spine/options_pb.js');
goog.exportSymbol('proto.spine.ui.Language', null, global);
/**
 * @enum {number}
 */
proto.spine.ui.Language = {
  UNDEFINED: 0
};

goog.object.extend(exports, proto.spine.ui);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../known_type_parsers.js');
